export const activityLogTranslations = {
    en: {
        // Page Header
        beneficiaryActivity: "Beneficiary Activity",
        activity: "activity",
        activities: "activities",

        // Filter
        filterByActivityType: "Filter by activity type",
        selectModule: "Select module",

        // Common Fields
        name: "Name",
        gender: "Gender",
        mobile: "Mobile",
        email: "Email",
        address: "Address",
        village: "Village",
        taluka: "Taluka",
        district: "District",
        pincode: "Pincode",
        date: "Date",
        tokenNo: "Token No",
        remark: "Remark",

        // Beneficiary Specific
        disease: "Disease",
        abhaCard: "ABHA Card",

        // Doctor Consultation
        diseases: "Diseases",
        advice: "Advice",
        observations: "Observations",
        referral: "Referral",
        otherDiseases: "Other Diseases",
        description: "Description",

        // Eye Camp Screening
        referralTypes: "Referral Types",
        diagnosticReferral: "Diagnostic Referral",
        isReferral: "Is Referral",
        referTo: "Refer To",
        otherHospital: "Other Hospital",
        visionAt6m: "Vision (6m)",
        rightEye: "RE",
        leftEye: "LE",

        // Pharmacy
        medicines: "Medicines",
        qty: "Qty",

        // STEMI Consultation
        symptoms: "Symptoms",
        heartRate: "Heart Rate",
        respiratoryRate: "Respiratory Rate",
        bloodPressure: "Blood Pressure",
        spo2: "SpO2",
        ecgFindings: "ECG Findings",
        files: "Files",
        file: "File",

        // ABHA Application
        fullName: "Full Name",
        dateOfBirth: "Date of Birth",
        aadharNo: "Aadhar No",
        licenseNo: "License No",

        // Scheme Referral
        schemes: "Schemes",
        unknownScheme: "Unknown Scheme",

        // Messages
        unknown: "Unknown",
        notAvailable: "N/A",
        invalidDate: "Invalid Date",
        noDetailsAvailable: "No details available for this activity type",
        errorDisplayingDetails: "Error displaying activity details",
        noActivitiesAvailable: "No Activities Available",
        noActivitiesToDisplay: "There are no beneficiary activities to display",
        noActivitiesFound: "No Activities Found",
        tryAdjustingFilters: "Try adjusting your filters to see more results"
    },
    mr: {
        // Page Header
        beneficiaryActivity: "लाभार्थी क्रियाकलाप",
        activity: "क्रियाकलाप",
        activities: "क्रियाकलाप",

        // Filter
        filterByActivityType: "क्रियाकलाप प्रकारानुसार फिल्टर करा",
        selectModule: "मॉड्यूल निवडा",

        // Common Fields
        name: "नाव",
        gender: "लिंग",
        mobile: "मोबाईल",
        email: "ईमेल",
        address: "पत्ता",
        village: "गाव",
        taluka: "तालुका",
        district: "जिल्हा",
        pincode: "पिनकोड",
        date: "तारीख",
        tokenNo: "टोकन क्रमांक",
        remark: "टिप्पणी",

        // Beneficiary Specific
        disease: "रोग",
        abhaCard: "आभा कार्ड",

        // Doctor Consultation
        diseases: "रोग",
        advice: "सल्ला",
        observations: "निरीक्षणे",
        referral: "संदर्भ",
        otherDiseases: "इतर रोग",
        description: "वर्णन",

        // Eye Camp Screening
        referralTypes: "संदर्भ प्रकार",
        diagnosticReferral: "निदान संदर्भ",
        isReferral: "संदर्भ आहे का",
        referTo: "संदर्भित करा",
        otherHospital: "इतर रुग्णालय",
        visionAt6m: "दृष्टी (६ मी)",
        rightEye: "उजवा डोळा",
        leftEye: "डावा डोळा",

        // Pharmacy
        medicines: "औषधे",
        qty: "प्रमाण",

        // STEMI Consultation
        symptoms: "लक्षणे",
        heartRate: "हृदय गती",
        respiratoryRate: "श्वसन दर",
        bloodPressure: "रक्तदाब",
        spo2: "एसपीओ२",
        ecgFindings: "ईसीजी निष्कर्ष",
        files: "फायली",
        file: "फाइल",

        // ABHA Application
        fullName: "पूर्ण नाव",
        dateOfBirth: "जन्मतारीख",
        aadharNo: "आधार क्रमांक",
        licenseNo: "परवाना क्रमांक",

        // Scheme Referral
        schemes: "योजना",
        unknownScheme: "अज्ञात योजना",

        // Messages
        unknown: "अज्ञात",
        notAvailable: "उपलब्ध नाही",
        invalidDate: "अवैध तारीख",
        noDetailsAvailable: "या क्रियाकलाप प्रकारासाठी तपशील उपलब्ध नाहीत",
        errorDisplayingDetails: "क्रियाकलाप तपशील प्रदर्शित करताना त्रुटी",
        noActivitiesAvailable: "क्रियाकलाप उपलब्ध नाहीत",
        noActivitiesToDisplay: "प्रदर्शित करण्यासाठी लाभार्थी क्रियाकलाप नाहीत",
        noActivitiesFound: "क्रियाकलाप आढळले नाहीत",
        tryAdjustingFilters: "अधिक परिणाम पाहण्यासाठी तुमचे फिल्टर समायोजित करा"
    }
};
